import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useAuth } from '../../commons/Auth';
import { useTranslation } from 'react-i18next';
import { useLoading } from '../../commons/Loading';
import { useAlert } from 'react-alert';
import {
  NumberParam,
  StringParam,
  useQueryParams,
  withDefault,
} from 'use-query-params';
import ContactsPresentational from './ContactsPresentational';

const { REACT_APP_DEFAULT_PAGINATION_LIMIT = 50 } = process.env;

const Contacts = ({ profile }) => {
  const [{ newToken, newIsAdmin } = {}] = useAuth();
  const [t] = useTranslation();
  const { showLoading, hideLoading } = useLoading();
  const alert = useAlert();

  const [contacts, setContacts] = useState([]);
  const [total, setTotal] = useState(0);

  const [query, setQuery] = useQueryParams({
    limit: withDefault(NumberParam, +REACT_APP_DEFAULT_PAGINATION_LIMIT),
    offset: NumberParam,
    email: withDefault(StringParam, ''),
  });

  const { limit, offset, email } = query;

  const fetchContacts = async () => {
    showLoading();

    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/marketing/contacts`,
      {
        headers: { Authorization: newToken },
        params: {
          limit,
          offset,
          email,
        },
      }
    );

    hideLoading();

    if (response instanceof Error) {
      return alert.error(t('COMMON:GENERIC_ERROR'));
    }

    const { data = [], headers = {} } = response;
    setContacts(data.contacts || []);
    setTotal(+headers['x-total-count']);
  };

  function onFilter(queryDiff) {
    if (
      (queryDiff.email && queryDiff.email !== email) || // first search
      (email && queryDiff.email === '') || // search deleted
      (queryDiff.limit && queryDiff.limit !== limit)
    ) {
      queryDiff.offset = 0; // return to first page
    }

    setQuery(queryDiff);
  }

  const updateContacts = async (data) => {
    showLoading();

    console.log('data:', data);

    const response = await axios.put(
      `${process.env.REACT_APP_API_URL}/marketing/contacts`,
      data,
      {
        headers: { Authorization: newToken },
      }
    );
    hideLoading();

    if (response instanceof Error) {
      const message = JSON.parse(response?.request?.response).message;
      return alert.error(message || t('COMMON:GENERIC_ERROR'));
    }

    alert.success(t('COMMON:SUCCESS_UPDATE'));
    fetchContacts();
  };

  useEffect(() => {
    fetchContacts();
  }, [limit, offset, email]);

  return (
    <ContactsPresentational
      data={contacts}
      profile={profile}
      query={query}
      total={total}
      onFilter={onFilter}
      updateContacts={updateContacts}
    />
  );
};

export default Contacts;
